import { BET_ON_TEEN_PATTI_BET_TYPES, } from '@ezugi/constants';

export const {
  // newline
  PAIR_PLUS_A,
  PAIR_PLUS_B,
  SIX_CARD,
  PLAYER_A,
  PLAYER_B,
} = BET_ON_TEEN_PATTI_BET_TYPES;

export const PAIR_PLUS = 'PairPlus';

export const SIDEBETS = {
  PAIR_PLUS_A,
  PAIR_PLUS_B,
  SIX_CARD,
  PAIR_PLUS,
};

export const MAIN_BETS = {
  PLAYER_A,
  PLAYER_B,
};

export default BET_ON_TEEN_PATTI_BET_TYPES;
